import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Header from './components/Header';
import DashboardPage, { PickUpPointDashboardRedirect } from './pages/DashboardPage';
import InvoiceAnalytics from './pages/InvoiceAnalytics';
import Customers from './pages/Customers';
import Orders from './pages/Orders';
import Stores from './pages/Stores';
import ExtraIncomes from './pages/ExtraIncome';
import OrderDetails from './pages/OrderDetails';
import Refunds from './pages/Refunds';
import CustomerDetails from './pages/CustomerDetails';
import WhatsappMessages from './pages/WhatsappMessages';
import CreditTransactions from './pages/CreditTransactions';
import ReferralDiscounts from './pages/ReferralDiscounts';
import OrderFinancialTransactions from './pages/OrderFinancialTransactions';
import ExternalFinancialTransactions from './pages/ExternalFinancialTransactions';
import ImportExternalTransactions from './pages/ImportExternalTransactions';
import FinanceMonthlyMatrix from './pages/FinanceMonthlyMatrix';
import FinanceReconciliation from './pages/FinanceReconciliation';
import ExpenseClaims from './pages/ExpenseClaims';
import PaymentRequests from './pages/PaymentRequests';
import PaymentRequestDetail from './pages/PaymentRequestDetail';
import Landing from './pages/Landing';
import Collections from './pages/Collections';
import PickUpPoints from './pages/PickUpPoints';
import PickUpPointDetails from './pages/PickUpPointDetails';
import NotificationPreferences from './pages/NotificationPreferences';
import Users from './pages/Users';
import Assistant from './pages/Assistant';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { ToastContainer } from 'react-toastify';
import { useAuth } from './hooks/useAuth';

function App() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <img src="/tini-logo.png" alt="Tini Express" className="h-16 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <>
    <Router>
      {isAuthenticated && <Header />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/invoice-analytics" element={<ProtectedRoute><InvoiceAnalytics /></ProtectedRoute>} />
        <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
        <Route path="/orders/:id" element={<ProtectedRoute><OrderDetails /></ProtectedRoute>} />
        <Route path="/stores" element={<ProtectedRoute><Stores /></ProtectedRoute>} />
        <Route path="/extra-income" element={<ProtectedRoute><ExtraIncomes /></ProtectedRoute>} />
        <Route path="/refunds" element={<ProtectedRoute><Refunds /></ProtectedRoute>} />
        <Route path="/whatsapp-messages" element={<ProtectedRoute><WhatsappMessages /></ProtectedRoute>} />
        <Route path="/credit-transactions" element={<ProtectedRoute><CreditTransactions /></ProtectedRoute>} />
        <Route path="/referral-discounts" element={<ProtectedRoute><ReferralDiscounts /></ProtectedRoute>} />
        <Route path="/order-financial-transactions" element={<AdminRoute><OrderFinancialTransactions /></AdminRoute>} />
        <Route path="/external-financial-transactions" element={<AdminRoute><ExternalFinancialTransactions /></AdminRoute>} />
        <Route path="/import-external-transactions" element={<AdminRoute><ImportExternalTransactions /></AdminRoute>} />
        <Route path="/finance-monthly-matrix" element={<AdminRoute><FinanceMonthlyMatrix /></AdminRoute>} />
        <Route path="/finance-reconciliation" element={<AdminRoute><FinanceReconciliation /></AdminRoute>} />
        <Route path="/expense-claims" element={<AdminRoute><ExpenseClaims /></AdminRoute>} />
        <Route path="/payment-requests" element={<ProtectedRoute><PaymentRequests /></ProtectedRoute>} />
        <Route path="/payment-requests/:id" element={<ProtectedRoute><PaymentRequestDetail /></ProtectedRoute>} />
        <Route path="/customers/:id" element={<ProtectedRoute><CustomerDetails /></ProtectedRoute>} />
        <Route path="/pick-up-points" element={<ProtectedRoute><PickUpPoints /></ProtectedRoute>} />
        <Route path="/pick-up-points/dashboard" element={<ProtectedRoute><PickUpPointDashboardRedirect /></ProtectedRoute>} />
        <Route path="/pick-up-points/:id" element={<ProtectedRoute><PickUpPointDetails /></ProtectedRoute>} />
        <Route path="/notification-preferences" element={<ProtectedRoute><NotificationPreferences /></ProtectedRoute>} />
        <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
        <Route path="/assistant" element={<ProtectedRoute><Assistant /></ProtectedRoute>} />
      </Routes>
    </Router>
    <ToastContainer position="top-right" autoClose={1500} style={{ top: '72px' }} />
    </>
  );
}

export default App;
